export default __webpack_public_path__ + "static/media/img4.5aa5ab21.PNG";